// 关于 KELK
const aboutKELK = {
  contentOne: `
  无锡凯尔克仪表阀门有限公司——中加技术联姻典范，高端流体控制领域全球解决方案服务商。以北美尖端流体控制科技为基，融合东方精密制造底蕴，铸就集研发智造、数智化服务于一体的行业标杆。依托加拿大凯尔克百年工艺传承与无锡仪表阀门深厚产业积淀，构建覆盖设计研发、精密铸造、智能装配的全链生态，专精超低温深冷阀、超临界高压阀等特种装备研发，产品赋能石油化工、清洁能源、环保治水等国民经济命脉领域，护航西气东输、超临界火电等国家重器工程。以智慧控流赋能产业升级，凭硬核品质重塑全球工业脉络
  `,
  /* contentTwo: `
  <h3>无锡凯尔克——高端流体控制领域的行业领导者</h3>
  <p>无锡凯尔克作为国家高新技术企业、江苏省创新型企业，始终以技术创新和智造实力引领行业发展。公司总部占地3.5万平方米，构筑了集研发、铸造、精密加工、检测认证于一体的现代化智造基地，配备数字化车间及国际领先的调节阀流量试验中心，为产品质量与性能提供硬核保障。</p>
  <h3 style="margin-top:10px;">精英团队：汇聚行业顶尖智慧</h3>
  <p>公司93%管理团队拥有本科及以上学历，其中15人研发天团含国家级仪表领域权威专家、中国仪器仪表学会理事及中化集团学科带头人；20人工程师团队覆盖智造工艺、品质管控全链路，配备CNAS认证实验室与全生命周期测试体系。</p>
  <h3 style="margin-top:10px;">硬核智造：定义行业标杆实力</h3>
  <p>公司全流程采用德系数控加工中心、五轴联动精密机床；自主掌握超临界阀门多级降压技术、低温深冷密封工艺等8项核心技术专利；流量试验系统精度达0.5级，可模拟-196℃至560℃极端工况，测试能力国内领先。</p>
  <h3 style="margin-top:10px;">行业认可：高端市场通行证</h3>
  <p>公司通过API 6D、ISO 15848等几十项国际权威认证，服务网络辐射全球30个国家和地区；年交付特种阀门超2万台，在储能、LNG等高端市场国产化率突破40%，彰显民族品牌担当。</p>
  `, */
  contentTwo: `
  <p style="margin-bottom:30px;">无锡凯尔克作为国家高新技术企业、江苏省创新型企业，始终以技术创新和智造实力引领行业发展。公司总部占地3.5万平方米，构筑了集研发、铸造、精密加工、检测认证于一体的现代化智造基地，配备数字化车间及国际领先的调节阀流量试验中心，为产品质量与性能提供硬核保障。公司93%管理团队拥有本科及以上学历，其中15人研发天团含国家级仪表领域权威专家、中国仪器仪表学会理事及中化集团学科带头人；20人工程师团队覆盖智造工艺、品质管控全链路，配备CNAS认证实验室与全生命周期测试体系。</p>
  <p>公司全流程采用德系数控加工中心、五轴联动精密机床；自主掌握超临界阀门多级降压技术、低温深冷密封工艺等8项核心技术专利；流量试验系统精度达0.5级，可模拟-196℃至560℃极端工况，测试能力国内领先。公司通过API 6D、ISO 15848等几十项国际权威认证，服务网络辐射全球30个国家和地区；年交付特种阀门超2万台，在储能、LNG等高端市场国产化率突破40%，彰显民族品牌担当。</p>
  `,
  contentThree: `
  <h3>无锡凯尔克——六十年匠心传承，铸就流体控制领域民族标杆</h3>
  <p>始于1963年，无锡凯尔克以六十载矢志不渝的专精精神，从中国控制阀行业先驱国企成功转型为全球化高端智造领军者。六十年风雨兼程，我们始终深耕流体控制领域，以"专一铸就专业"的信念，书写中国工业阀门从追赶到领跑的史诗篇章。</p>
  <h3 style="margin-top:10px;">传承与超越：大国工匠精神的当代诠释</h3>
  <ul>
      <li style="list-style-position:inside!important;list-style:disc;">赓续国企时代"团结守信、敬业奉献"的文化基因，融合全球化3C价值体系（Crew·人才为本、Customer·客户智联、Core·技术登峰），构建产学研用一体化创新生态；</li>
      <li style="list-style-position:inside!important;list-style:disc;">主导参与12项国家级流体控制行业标准制定，累计获发明专利28项，以"中国精度"打破超低温密封、多级降压等7项国际技术垄断；</li>
      <li style="list-style-position:inside!important;list-style:disc;">建成国家级流体控制实验室，配备-268℃深冷试验舱、100MPa超高压爆破平台，测试能力对标API 6D/ISO 15848国际顶尖标准。</li>
  </ul>
  <h3 style="margin-top:10px;">硬核实力：六十年专注成就全球话语权</h3>
  <ul>
      <li style="list-style-position:inside!important;list-style:disc;">全产业链自主可控：以60%核心部件自主化研发+40%国际顶尖供应链协同（德国填料、日本精密弹簧、美国航天级膜片），打造"性能比肩进口、成本优化30%"的国民精品；</li>
      <li style="list-style-position:inside!important;list-style:disc;">全生命周期服务：依托行业唯一的"制造+维保"双擎体系，300人专家团队提供从阀门健康诊断到智能改造的一站式服务，年修复进口高端阀门超5000台；</li>
      <li style="list-style-position:inside!important;list-style:disc;">全场景解决方案：产品覆盖-268℃至1200℃极端温域，压力等级横跨Class 150#至4500#，服务三峡电站、中俄东线等17项国家重大工程。</li>
  </ul>
  <h3 style="margin-top:10px;">未来征途：以中国智造定义行业新坐标</h3>
  <p>面向"双碳"时代，我们以氢能超高压阀、核电智能主蒸汽调节阀等战略产品，助力全球能源转型；通过"一带一路"技术输出，在东南亚、中东建成3大海外服务中心。六十甲子再出发，无锡凯尔克将持续以"做全球工业脉动的中国控制器"为使命，让世界见证东方工匠的硬核力量！</p>
  `,
  contentFour: '选择了无锡凯尔克，也就是选择了高性能价格比的产品，公司一直以关键零部件进口（如填料，弹簧，膜片，平衡密封环等）的方式制造出质量接近于原装，价格接近于国产的高性能价格比的产品。公司还设有一支专业的阀门检修与维护团队，对外承接各类阀门的维保和检修项目，基于阀门制造企业的优势，在业内享有很高的声誉',
  contentFive: '无锡凯尔克致力于新产品的开发和设计，将一如既往的为客户提供更多流体控制的解决方案',
  contentSix: '无锡凯尔克是一个实力型，品牌型，成长型多元发展的企业。动力源于传承卓越，品质在于历久弥新',
  team: {
    title: '研发团队27名包含',
    content: `
    2名中国仪器仪表学会理事<br />
    1名中国化工集团学科带头人<br />
    2名国家级仪表高级工程师
    `
  },
  Base: {
    title: '生产基地',
    content: '在无锡拥有集铸造、加工、装配及服务的生产场地2万平方米'
  },
  sales: {
    title: '销售网络',
    content: '6大区域性分公司，15个服务中心，全力打造KELK品牌'
  },
}

// 我们的历史
const ourHistory = {
  titleOne: 'KELK 里程碑',
  contentOne: `
  60年匠心传承，品质铸就未来。无锡凯尔克自1965年成立以来，已经走过了60年的风雨历程。从国营企业到外资企业再到民营企业，经历了改革开放的浪潮，也见证了历史的变迁，自合资启航，无锡凯尔克以“国产替代进口”为使命，深耕控制阀领域六十余载。从引进尖端技术到建成自主高端产线，从首台低温深冷阀打破垄断到核电、超临界等特种阀跻身国家级工程，每一步都烙印着创新与突破。如今，公司以“高端控制阀”之誉，服务全球能源、化工、环保等千家企业，以技术升级持续赋能工业智造，书写中国流体控制的里程碑篇章
  `,
  historyVideo:require('@/assets/images/about/about.mp4'),
  list: [
    {
      year: '1965年',
      content: '国营无锡仪表阀门厂建立'
    },
    {
      year: '1973年',
      content: '内迁四川建立川仪十一厂'
    },
    {
      year: '1988年',
      content: '无锡仪表阀门厂引进日本工装710C高性能密封蝶阀技术'
    },
    {
      year: '1989年',
      content: '与日本工装合资成立无锡工装阀门铸造有限公司'
    },
    {
      year: '1995年',
      content: '与日本工装合资成立无锡工装自控工程有限公司'
    },
    {
      year: '2000年',
      content: `
      产权改制，成立无锡仪表阀门有限公司<br />
      为工装自控工程（无锡）有限公司代工，直到2013年底
      `
    },
    {
      year: '2013年',
      content: '通过特种设备制造许可证A1、A2及ISO相关认证'
    },
    {
      year: '2014年',
      content: `
      成立无锡凯尔克仪表阀门有限公司（与加拿大KELK Flow Control Co.Ltd合资）<br />
      在中国大陆各地区建立销售分公司
      `
    },
    {
      year: '2018年',
      content: `
      与深圳万讯深度合作（与深圳万讯自控股份有限公司建立合资企业）<br />
      生产力扩大一倍，建立更完善的销售网络
      `
    },
    {
      year: '2020年',
      content: '获得国家高新技术企业认证获得省级企业上云及智能制造车间'
    },
  ]
}

// 网络分布
const networkDistribution = {
  titleOne: 'KELK 网络分布',
  contentOne: `
  无锡凯尔克以无锡总部为核心，辐射华东、华南、华北等六大区域，构建覆盖全国30个省市的本地化服务网络。300+专业工程师团队与50个备件仓联动，承诺8小时抵达国内任一客户现场，提供从售前选型咨询、安装调试到故障排查的全周期服务。依托数字化远程诊断系统与标准化服务流程，实现7×24小时快速响应，年均解决紧急问题超2000例，以客户 “零库存” 和与客户 “零距离” 服务缩短客户停机时间，为工业控流安全保驾护航
  `,
  imgaeOne: require('@/assets/images/about/net1.jpg'),
  network:[
    { name: "文字暂代加拿大总公司", address:"  地址：文字暂代文字暂代加拿文字暂代加拿大卑诗三角洲公司德文", tel:"电话：+1604 560 0588", mail: "邮箱：+1604 385 3173"},
    { name: "文字暂代加拿大总公司", address:"  地址：文字暂代文字暂代加拿大卑诗三洲公司德文", tel:"电话：+1604 560 0588", mail: "邮箱：+1604 385 3173"},
    { name: "文字暂代加拿大总公司", address:"  地址：文字暂代文字暂代加拿大卑诗三角洲公德文", tel:"电话：+1604 560 0588", mail: "邮箱：+1604 385 3173"},
    { name: "文字暂代加拿大总公司", address:"  地址：文字暂代文字暂代加字暂代加拿大拿大卑洲公司德文", tel:"电话：+1604 560 0588", mail: "邮箱：+1604 385 3173"},
    { name: "文字暂代加拿大总公司", address:"  地址：文字暂代文字暂代加拿大卑诗三角公司德文", tel:"电话：+1604 560 0588", mail: "邮箱：+1604 385 3173"},
    { name: "文字暂代加拿大总公司", address:"  地址：文字暂代文字暂代加拿大洲公司德文", tel:"电话：+1604 560 0588", mail: "邮箱：+1604 385 3173"},
    { name: "文字暂代加拿大总公司", address:"  地址：文字暂代文字暂代加拿大卑诗三角洲公司文", tel:"电话：+1604 560 0588", mail: "邮箱：+1604 385 3173"},
    { name: "文字暂代加拿大总公司", address:"  地址：文字暂代文字暂代加拿大卑诗三角洲公司文", tel:"电话：+1604 560 0588", mail: "邮箱：+1604 385 3173"},
    { name: "文字暂代加拿大总公司", address:"  地址：文字暂代文字暂代加拿大卑诗字暂代加拿大字暂代加拿大三角洲公司德文", tel:"电话：+1604 560 0588", mail: "邮箱：+1604 385 3173"},
    { name: "文字暂代加拿大总公司", address:"  地址：文字暂代文字暂代加拿大卑诗三角洲公德文", tel:"电话：+1604 560 0588", mail: "邮箱：+1604 385 3173"},
    { name: "文字暂代加拿大总公司", address:"  地址：文字暂代文字暂代字暂代加加拿大卑诗三角洲公司德文", tel:"电话：+1604 560 0588", mail: "邮箱：+1604 385 3173"},
    { name: "文字暂代加拿大总公司", address:"  地址：文字暂代文字暂诗三角洲公司德文", tel:"电话：+1604 560 0588", mail: "邮箱：+1604 385 3173"},
  ],
}

// 我们的能力
const ourAbility = {
  titleOne: 'KELK 的能力',
  contentOne: `
  无锡凯尔克以中加技术融合为基石，在阀门设计端实现全生命周期定制化开发，通过工况模拟、流体力学分析与模块化结构优化，专精低温深冷阀、超临界高压阀等特种阀门设计，满足电站、空分等极端工况需求
  `,
  contentTwo: `
  生产端依托精密铸造、高精度加工及智能化装配产线，执行ISO 9001/API国际标准，以微米级公差控制保障高温、强腐蚀环境下的长效稳定性；供应链端整合全球化资源，与特种钢材、密封件头部供应商协同，通过ERP系统实现订单敏捷响应与快速交付，为客户提供兼具技术领先性与成本竞争力的工业控流解决方案
  `,
  list: [
    {
      title: '工程设计能力',
      content: `
      无锡 KELK 引进加拿大KELK先进的设计技术，采用先进的软件对产品进行正向设计和逆向工程<br />
      采用 CFD/FEM 计算进行流体分析，同时运用 Solidworks 等三维设计软件结合有限元分析对阀体和阀内件进行应力 和变形分析<br />
      主要使用设计工具有: AutoCAD, MasterCam, SolidWorks 等
      `
    },
    {
      title: '生产铸造能力',
      content: `
      无锡 KELK 拥有自己的铸造工厂。有砂铸和精铸两种工艺，可以制造各种特殊材料的铸件。主要设备有快速中频电炉，热处理炉，光谱分析仪等<br />
      无锡 KELK 铸造工厂保证了产品质量，提高了产品性能，加快了交货进度，提高了研发速度，降低了生产成本
      `,
      image: require('@/assets/images/about/ability2-4.jpg')
    },
    {
      title: '加工焊接能力',
      content: `
      无锡 KELK 所有关键零部件都采用进口或者由工厂自行加工完成,加工车间拥有 CNC加工中心、数控立车、数控镗床、卧式镗床、深孔钻、多轴钻床等主要设备<br />
      无锡 KELK 各类机械工作设备构成了较为完整的工艺流程，完全能够满足产品制造和特殊工艺的要求。关键零部件的进口确保了可靠的阀门质量。主要相关设备包括︰自动堆焊接机、真空热处理炉，电阻炉等
      `
    },
    {
      title: '供应管理能力',
      content: `
      无锡 KELK 拥有一个牢固可靠的供应商伙伴关系。我们致力于发展长期可信赖的合作模式，双方有着共同的目标，不仅发展战略性原材料联盟，还在先进技术的发展上寻求合作。我们关键零部件都采用国际一流品牌，优质的供应链确保了整体产品的可靠性<br />
      这种牢固的合作伙伴关系，带给了我们很多好处：提高了质量，缩短了供货周期；降低了原材料及零部件的库存，降低管理费用；加强了与供应商的沟通，提高了各种需求的准确度
      `
    }
  ]
}

// 我们的品质
const ourQuality = {
  titleOne: 'KELK 的品质',
  contentOne: `
  无锡凯尔克依托ASME认证实验室实施全流程严苛品控体系，配备工业级无损探伤仪、光谱分析仪及-196℃超低温至42MPa高压极端工况测试平台，通过多维度验证保障阀门关键部件零缺陷交付，保障极端环境下设计寿命达20年
  `,
  contentTwo: `
  产品检验与实验执行ISO 15848、API 598等20余项标准，全流程进行气密性、寿命周期及极端工况模拟测试，出厂合格率达99.98%；品控管理依托数字化追溯系统，贯穿原材料入库至成品交付，全员参与质量节点管控，以“零缺陷”标准为全球千家企业提供长效稳定的流体控制保障
  `,
  list: [
    {
      title: '实验和检验设备',
      content: `
      KELK 拥有光谱分析、探伤检验、硬度检验、拉伸和冲击检验、扭矩测试、强度和泄漏检验、膜厚检验等设备，为优质的产品的质量提供了可靠的保证<br />
      KELK 流体实验中心能够对包括球形阀、球阀、蝶阀等低磅级和小口径阀门进行流量实验。同时能够模拟阀门在设计工况下（压力，介质，温度）的各种实验和检验
      `
    },
    {
      title: '产品检验和试验',
      content: `
      控制阀工作的可靠性主要体现在出厂检验及周期维护上面。除了标准检验以外,为了预测他们的可靠性需要在苛刻的操作环境下，对阀门或零部件进行各种试验，以确保生产出来的阀门有可靠的保证性<br />
      为了发展 KELK 品牌的控制阀，我们付出了不寻常的努力。例如︰我们对阀门做高低温试验、反复对阀座泄漏量、执行机构膜片和填料等做周期性疲劳实验
      `
    },
    {
      title: '质量与管理',
      content: `
      通过对产品、零部件实行跟踪管理；对原材料、零部件、成品等进行定点、分区管理；保存完整的产品质量档案为顾客在维修或是更换备件时提供及时有效的数据。实现产品及关键零部件的可追溯性，给顾客和我们自己都带来极大方便和利益
      `
    },
  ]
}

// 可持续发展
const sustainableDevelopment = {
  titleOne: 'KELK 的愿景',
  contentOne: `
  以创新为核，成为全球控制阀领域的标杆品牌<br />
  秉持“发展与创新是永恒主题”，深耕智能化、绿色低碳技术，持续推动工业控流行业革新升级<br />
  全员共创价值，以协作文化凝聚力量，共享每一份技术突破与市场成就
  `,
  list: [
    {
      title: '公司战略',
      content: `
      全球理念和行动：全球都拥有生产基地和分销商；<br />
      高质量的安装服务标准：进而提高成本效率和可靠性；<br />
      增值方案的提供者：为您提供品质卓越的解决方案，进行后续跟踪并提供必要的技术支持和售后服务；<br />
      面向未来的解决方案：研发聚焦低碳节能与智能化控制阀，以每年不低于15%的研发投入推动可持续发展。
      `
    },
    {
      title: '卓越管理',
      content: `
      卓越运营的管理理念：优化产品与服务的质量，增加客户满意度，创造更高的价值，实现企业全方位的长期竞争力；<br />
      高绩效运营管理团队：由中西融合的高团队践行精益管理，将客户满意度纳入全员KPI，承诺每年度客户复购率提升10%；<br />
      高绩效运营生产团队：无锡凯尔克（KELK）制造基地着重于体系的持续有效和不断完善，严格要求的全新生产模式。
      `
    },
    {
      title: '公司承诺',
      content: `
      全球行动：以无锡制造基地为枢纽，联动全球分销网络与合作伙伴，实现本土化快速响应与资源协同，降低客户供应链成本；<br />
      质量锚定：执行高于API/ISO标准的安装服务体系，通过模块化设计与全流程数字化追溯，提升产品可靠性并减少全生命周期维护成本；<br />
      价值延伸：不止于产品交付，更提供定制化流体控制方案、远程智能诊断及24小时技术支援，确保客户运营效率持续优化；<br />
      卓越兑现：由中西融合的高绩效团队践行精益管理，将客户满意度纳入全员KPI，承诺每年度客户复购率提升10%。
      `
    },
    {
      title: '公司HSE',
      content: `
      安全为本：建立ISO 14001环境管理体系与ISO 45001职业健康标准，全员年度安全培训覆盖率100%，生产事故率低于0.1‰；<br />
      绿色智造：制造基地采用清洁能源与循环水系统，2025年前实现碳减排30%，危废合规处置率100%；<br />
      员工福祉：定期职业健康监测，配备智能化安全防护装备，保障员工工伤率趋近于零，筑牢可持续发展的企业根基；<br />
      责任延伸：联合供应商构建绿色供应链，要求合作方100%通过环保合规审核，共同履行全球可持续发展承诺。
      `
    },
  ]
}

// 我们的资质
const ourQualifications = {
  titleOne: '资质和荣誉',
  contentOne: `
  专注流体控制解决方案，持有ISO 9001等30余项全球权威认证，不断满足客户的高标准 <br />
  资质覆盖设计研发、精密制造到全场景检测全链路，严格遵循API、ASME等国际标准，确保各类产品99.9%出厂合格率 <br />
  全员参与的品控体系，持续升级技术标准，兑现高效、安全、长效的控流承诺
  `,
  titleTwo: '我们目前的认证如下',
}


export default {
  titleOne: '关于 KELK',
  tabnav: {
    about: '公司简介',
    history: '我们的历史',
    network: '我们的网络',
    ability: '我们的能力',
    quality: '我们的品质',
    development: '可持续发展',
    qualifications: '我们的资质'
  },
  contentOne: `
    无锡凯尔克是一家中国与加拿大合资的专业控制阀制造商<br />
    专注高端控制阀国产化替代，产品涵盖低温深冷阀、高温高压阀等全系列，服务于石油化工、能源环保领域<br />
    提供全周期技术支持与维护，推动国产控制阀技术升级，赋能工业高效安全控流`,
  contentThree: '无锡凯尔克仪表阀门有限公司是一家中国与加拿大合资的专业控制阀制造商。通过从加拿大凯尔克引进先进设计技术与管理经验，结合原无锡仪表阀门有限公司的铸造、加工及装配能力，公司专注打造国产高端控制阀，致力于提供国产替代进口的高性能流体控制解决方案。作为控制阀供应商领域的领先企业，无锡凯尔克开发了包括调节阀、开关阀、低温深冷阀、高温高压阀、自力式阀在内的全系列产品，并以高精度控制阀技术为核心，为石油、化工、空分、冶金、电力、能源、环保等行业提供定制化服务。公司产品广泛应用于石油化工、天然气管道、有色冶金、工业气体等场景，覆盖从国家级重点项目到工业自动化系统的多样化需求。除核心产品外，公司提供控制阀维修、控制阀安装维护服务以及技术支持，解决客户从控制阀选型咨询到售后保障的全周期问题。依托严格的国际质量管理体系，无锡凯尔克持续推动国产高端控制阀的技术升级，助力工业领域实现高效、安全的流体控制',
  contentFour: {
    history: {
      title: '公司历史',
      content: `
      60年匠心传承，品质铸就未来。无锡凯尔克自1965年成立以来，已经走过60年风雨历程，从国营企业到外资企业再到民营企业.....
      `
    },
    area: {
      title: '应用领域',
      content: '无锡凯尔克为石油天然气、石化化工、精细化工、冶金有色、工业气体、能源环保、电力拖动等工业控制领域和仪器仪表行业供应设......'
    },
    service: {
      title: '服务至上',
      content: '无锡凯尔克以工厂为依托，可承揽各种品牌的控制阀检修维护服务。公司在全国各地设有维修服务基地，配有移动式车间及配套的......'
    }
  },
  about60thImg: require('@/assets/images/about/about60th.png'),
  aboutVideo:require('@/assets/images/about/about.mp4'),
  
  aboutKELK,
  ourHistory,
  networkDistribution,
  ourAbility,
  ourQuality,
  sustainableDevelopment,
  ourQualifications
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/aboutPage.js